/* ============================================================
   Mobile gallery slider — Prestige-style page dots.

   The product gallery is already a swipeable Flickity carousel on
   touch devices (theme sets `draggable` on mobile), but it ships with
   pageDots:false and shows a horizontal thumbnail strip beneath the
   image instead. On mobile we hide that strip (see custom.css) and add
   a row of page dots under the image so customers get the familiar
   swipe-with-dots experience.

   This layer is fully decoupled from the theme's minified gallery code:
   - It reads which slide is active by observing Flickity's `is-selected`
     class on the carousel items (set by Flickity on every swipe).
   - It navigates by triggering the theme's OWN hidden thumbnail click
     handler (which calls flickityInstance.selectCell internally), so we
     never need a reference to the private Flickity instance.
   ============================================================ */
(function () {
  'use strict';

  function init() {
    var galleries = document.querySelectorAll('.product-gallery');
    for (var i = 0; i < galleries.length; i++) {
      setupGallery(galleries[i]);
    }
  }

  function setupGallery(gallery) {
    if (gallery.__mgsInit) return;

    var carousel = gallery.querySelector('.product-gallery__carousel');
    if (!carousel) return;

    var items = [].slice
      .call(carousel.querySelectorAll('.product-gallery__carousel-item'))
      .filter(function (it) {
        return !it.classList.contains('is-filtered');
      });

    // Nothing to page through with a single slide.
    if (items.length < 2) return;

    gallery.__mgsInit = true;

    var dotsWrap = document.createElement('div');
    dotsWrap.className = 'mgs-dots';

    var dots = items.map(function (item) {
      var mediaId = item.getAttribute('data-media-id') || '';
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'mgs-dot';
      dot.setAttribute('aria-label', 'Go to image');
      dot.setAttribute('data-media-id', mediaId);
      dot.addEventListener('click', function () {
        // Drive the theme's own carousel via the matching (hidden) thumbnail.
        var thumb = gallery.querySelector(
          '.product-gallery__thumbnail[data-media-id="' + mediaId + '"]'
        );
        if (thumb) thumb.click();
      });
      dotsWrap.appendChild(dot);
      return dot;
    });

    var wrapper =
      gallery.querySelector('.product-gallery__carousel-wrapper') ||
      carousel.parentNode;
    wrapper.appendChild(dotsWrap);

    // Navigate by index, driving the theme's own carousel via the matching
    // (hidden) thumbnail. Wraps around at both ends.
    function goToIndex(idx) {
      if (idx < 0) idx = items.length - 1;
      if (idx >= items.length) idx = 0;
      var mediaId = items[idx].getAttribute('data-media-id');
      var thumb = gallery.querySelector(
        '.product-gallery__thumbnail[data-media-id="' + mediaId + '"]'
      );
      if (thumb) thumb.click();
    }

    function currentIndex() {
      var selected = carousel.querySelector(
        '.product-gallery__carousel-item.is-selected'
      );
      var id = selected ? selected.getAttribute('data-media-id') : null;
      for (var i = 0; i < items.length; i++) {
        if (items[i].getAttribute('data-media-id') === id) return i;
      }
      return 0;
    }

    // Prev/next arrows (shown on desktop where there is no swipe).
    function makeArrow(dir, label) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'mgs-arrow mgs-arrow--' + (dir < 0 ? 'prev' : 'next');
      btn.setAttribute('aria-label', label);
      btn.innerHTML = '<span class="mgs-arrow__icon"></span>';
      btn.addEventListener('click', function () {
        goToIndex(currentIndex() + dir);
      });
      return btn;
    }
    wrapper.appendChild(makeArrow(-1, 'Previous image'));
    wrapper.appendChild(makeArrow(1, 'Next image'));

    function syncActive() {
      var selected = carousel.querySelector(
        '.product-gallery__carousel-item.is-selected'
      );
      var selectedId = selected ? selected.getAttribute('data-media-id') : null;
      for (var i = 0; i < dots.length; i++) {
        var on = dots[i].getAttribute('data-media-id') === selectedId;
        dots[i].classList.toggle('is-active', on);
        dots[i].setAttribute('aria-current', on ? 'true' : 'false');
      }
    }

    // Reflect every Flickity selection change (swipe, thumbnail, variant
    // image swap) into the active dot.
    if (typeof MutationObserver === 'function') {
      var observer = new MutationObserver(syncActive);
      for (var j = 0; j < items.length; j++) {
        observer.observe(items[j], {
          attributes: true,
          attributeFilter: ['class'],
        });
      }
    }
    syncActive();

    // The theme's own Flickity instance (created after this runs), reachable
    // via Flickity.data once it exists.
    function getFlkty() {
      return window.Flickity && window.Flickity.data
        ? window.Flickity.data(carousel)
        : null;
    }

    // Select the first slide WITHOUT scrolling the page (isInstant = true).
    function selectFirst() {
      var flkty = getFlkty();
      if (flkty && typeof flkty.select === 'function') {
        flkty.select(0, false, true);
      } else {
        var firstThumb = gallery.querySelector('.product-gallery__thumbnail');
        if (firstThumb) firstThumb.click();
      }
    }

    // (#2) Enable swipe wrap-around so a swipe past the last image loops back
    // to the first. The theme inits Flickity with wrapAround:false; flip it on
    // once the instance exists and rebuild its wrap cells.
    function enableWrap(attempt) {
      var flkty = getFlkty();
      if (!flkty) {
        if (attempt < 8) setTimeout(function () { enableWrap(attempt + 1); }, 250);
        return;
      }
      if (!flkty.options.wrapAround) {
        flkty.options.wrapAround = true;
        if (typeof flkty.reloadCells === 'function') flkty.reloadCells();
        if (typeof flkty.reposition === 'function') flkty.reposition();
        flkty.select(flkty.selectedIndex || 0, false, true);
      }
      // Fallback: if flipping wrapAround doesn't make the SWIPE loop, wrap
      // manually — a forward swipe at the last cell jumps to the first (and a
      // backward swipe at the first jumps to the last). Only fires when
      // Flickity itself didn't already wrap (selectedIndex still at the end).
      if (flkty.on && !flkty.__mgsWrap) {
        flkty.__mgsWrap = true;
        var moveX = 0;
        flkty.on('dragMove', function (e, pointer, v) { moveX = (v && v.x) || 0; });
        flkty.on('dragEnd', function () {
          var last = (flkty.cells ? flkty.cells.length : 0) - 1;
          if (last > 0) {
            if (flkty.selectedIndex === last && moveX < -40) flkty.select(0, false, false);
            else if (flkty.selectedIndex === 0 && moveX > 40) flkty.select(last, false, false);
          }
          moveX = 0;
        });
      }
    }
    enableWrap(0);

    // (#2b) Reliable swipe wrap-around, independent of the Flickity global.
    // Prestige bundles Flickity, so `window.Flickity` is undefined and the
    // option-flip in enableWrap() never runs. Instead, watch touch swipes on the
    // carousel and loop at the ends via the theme's own thumbnail navigation:
    // a left-swipe that STARTS on the last image jumps to the first, and a
    // right-swipe that starts on the first jumps to the last. Middle swipes are
    // left entirely to Flickity (startIdx isn't a boundary, so we no-op).
    (function () {
      var startX = null, startY = 0, startIdx = 0;
      carousel.addEventListener('touchstart', function (e) {
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        startIdx = currentIndex();
      }, { passive: true });
      carousel.addEventListener('touchend', function (e) {
        if (startX == null) return;
        var dx = e.changedTouches[0].clientX - startX;
        var dy = e.changedTouches[0].clientY - startY;
        startX = null;
        // Only a deliberate, horizontally-dominant swipe wraps. A vertical
        // page scroll with slight sideways drift must NEVER jump the gallery,
        // so require real horizontal travel AND horizontal > vertical movement.
        if (Math.abs(dx) < 45 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
        var last = items.length - 1;
        if (dx < 0 && startIdx === last) goToIndex(0);
        else if (dx > 0 && startIdx === 0) goToIndex(last);
      }, { passive: true });
    })();

    // (#3) On any product-option change (size / framing / white border), snap
    // the gallery back to the first image. framing-options.js dispatches
    // bubbling 'change' events on the underlying selects.
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      // Default page selects live in .product-form; the LE page uses its own
      // .fo-variants / .le2 markup (no .product-form), so match both.
      if (t.closest('.product-form') || t.closest('.fo-variants') || t.closest('.le2')) {
        // framing.js swaps the frame overlay and repositions the carousel a
        // beat later, which can undo a single reset (hence the "works
        // sometimes"). Fire it a few times to reliably land on the first image.
        setTimeout(selectFirst, 0);
        setTimeout(selectFirst, 140);
        setTimeout(selectFirst, 340);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Premium Shadow Box: toggle a class on the gallery frame so a deeper drop
  // shadow (in custom.css) reads its deeper profile. Default product page only
  // — skip the LE template. Detects the box frame from the hidden Frame select
  // value (…"Box"/"Shadow"…). Does not touch framing.js.
  (function () {
    if (document.querySelector('.le-template')) return;
    function isBox() {
      var sel = document.querySelector('.product-form__option.Frame select, select[data-select-name="Frame"]');
      return !!(sel && /box|shadow/i.test(sel.value));
    }
    function update() {
      var mf = document.querySelector('.product-gallery__carousel-item.main-frame');
      if (mf) mf.classList.toggle('is-shadow-box', isBox());
    }
    document.addEventListener('change', function () { setTimeout(update, 30); });
    document.addEventListener('click', function () { setTimeout(update, 60); });
    window.addEventListener('load', function () { setTimeout(update, 300); });
    setTimeout(update, 400);
  })();
})();

